import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SideNav from './components/sidenav';
import DashboardPage from './pages/dashboard/Dashboard.js';
import RobotsPage from './pages/robots/app';
import InterventionPage from './pages/intervention/app';
import IssuesPage from './pages/issues/app';
import ManagementPage from './pages/management/app';
import MissionsPage from './pages/missions/app';
import ReportsPage from './pages/reports/app';
import SchedulingPage from './pages/scheduling/app';
import SoftwarePage from './pages/software/app';import TasklistPage from './pages/tasklist/app';
import RobotComponent from './pages/robots/robot_component';
import ManagementComponent from './pages/management/management_component';
import EpComponent from './pages/management/endpoint/ep_component.js';
import AIComponent from './pages/management/ai/ai_component.js';
import CreateSite from './pages/management/site/create_site.js';
import EditSite from './pages/management/site/edit_site.js';
import CreateType from './pages/management/type/create_type.js';
import EditType from './pages/management/type/edit_type.js';
import CreateSoftwareVersion from './pages/management/software/create_software.js';
import EditSoftwareVersion from './pages/management/software/edit_software.js';
import CreateRobotVersion from './pages/management/version/create_robot_version.js';
import EditRobotVersion from './pages/management/version/edit_robot_version.js';
import CreateRobotLivestream from './pages/management/livestream/create_robot_livestream.js';
import EditRobotLivestream from './pages/management/livestream/edit_robot_livestream.js';
import CreateStatusCode from './pages/management/status_code/create_status_code.js';
import EditStatusCode from './pages/management/status_code/edit_status_code.js';
// import MockData from './pages/alert_table/mockData.json';
import AlertTable from './pages/alert_table/AlertTable';
import DetailsPage from './pages/alert_table/DetailsPage';
import ProfileEditPage from './pages/profile/ProfileEditPage';
import SecurityPage from './pages/security/SecurityPage';
import RobotControlPage from './pages/robot_control/RobotControl';
import { useKeycloak } from "@react-keycloak/web"
import LoadingScreen from './components/LoadingScreen'
import { ThemeProvider } from './ThemeContext';
import "./App.css";

// export const DataContext = createContext();

const App = () => {
  const { keycloak, initialized } = useKeycloak();
  // const [mockData, setMockData] = useState([]);

  // Loading mock data (you can replace this with an API call)
  // useEffect(() => {
  //   setMockData(MockData);
  // }, []);

  if (!initialized) {
    return (
      <ThemeProvider>
        <LoadingScreen open={!initialized}/>
      </ThemeProvider>
    );
  }


  return (
      <ThemeProvider>
      <Router context={{ isAuthenticated: keycloak.authenticated }}>
        <Routes>
          <Route path="/" element={<SideNav />}>
            <Route path="/" element={<RobotsPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="robots" element={<RobotsPage />} />
            <Route path="/robots/:name" element={<RobotComponent />} />
            <Route path="intervention" element={<InterventionPage />} />
            <Route path="issues" element={<IssuesPage />} />
            <Route path="managements" element={<ManagementPage />} />
            <Route path="/managements/:name" element={<ManagementComponent />} />
            <Route path="/managements/endpoint_management/:name" element={<EpComponent />} />
            <Route path="/managements/ai_management/:name" element={<AIComponent/>} />
            <Route path="/managements/site_management/:id" element={<EditSite/>} />
            <Route path="/managements/site_management/create" element={<CreateSite/>} />
            <Route path="/managements/type_management/:id" element={<EditType/>} />
            <Route path="/managements/type_management/create" element={<CreateType/>} />
            <Route path="/managements/software_management/:id" element={<EditSoftwareVersion/>} />
            <Route path="/managements/software_management/create" element={<CreateSoftwareVersion/>} />
            <Route path="/managements/robot_version_management/:id" element={<EditRobotVersion/>} />
            <Route path="/managements/robot_version_management/create" element={<CreateRobotVersion/>} />
            <Route path="/managements/robot_livestream_management/:id" element={<EditRobotLivestream/>} />
            <Route path="/managements/robot_livestream_management/create" element={<CreateRobotLivestream/>} />
            <Route path="/managements/status_code_management/:id" element={<EditStatusCode/>} />
            <Route path="/managements/status_code_management/create" element={<CreateStatusCode/>} />
            <Route path="missions" element={<MissionsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="scheduling" element={<SchedulingPage />} />
            <Route path="software" element={<SoftwarePage />} />
            <Route path="tasklist" element={<TasklistPage />} />
            <Route path="alerts" element={<AlertTable />} />
            <Route path="robot_control" element={<RobotControlPage />} />
            <Route path="alerts/:id" element={<DetailsPage />} />
            <Route path="profile" element={<ProfileEditPage />} />
            <Route path="/security" element={<SecurityPage />} />
          </Route>
        </Routes>
      </Router>
      </ThemeProvider>
  );
};

export default App;
